import React from "react";
import { Link } from "react-router-dom";
import { getAppConfig } from "@config/appConfig";
import { useExperiences } from "@hooks/useExperiences";

import "./style.scss";

const SelectExperienceSessions = () => {

    const config = getAppConfig();


    const experiences = useExperiences() ?? [];

    return (
        <div className="experiences__link-list">
            {experiences.map(({ code, label, image }) => (
                <Link
                    to={`/experiences/${label.toLowerCase()}`}
                    role="button"
                    key={code}
                    className="experiences__item-button"
                >
                    <img
                        className="experiences__image"
                        src={`${config?.cdnUrl}asset/img/${image}`}
                        alt={`${label} Experience`}
                    />
                    <div className={`experiences__item-text experiences__item-text--${code}`}>
                        {label}
                    </div>
                </Link>
            ))}
        </div>
    );
};

export default SelectExperienceSessions;
